// extracted by mini-css-extract-plugin
export default {"labelText":"AnimalChartLabel_labelText__27vEj","spin":"AnimalChartLabel_spin__XVswB"};